import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  ColorInput,
  Text,
  Select,
} from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataGPU } from "./types";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto } from "@tabler/icons-react";

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: (editedData: RowDataGPU) => void;
  data: RowDataGPU;
}

const EditGPUModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onEdit,
  data,
}) => {
  const [editedData, setEditedData] = useState<RowDataGPU>(data);

  const imageDropzoneRef = useRef<() => void>(null);

  useEffect(() => {
    setEditedData(data);
  }, [data]);

  const handleEdit = () => {
    // Perform validation or additional logic as needed
    onEdit(editedData);
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit GPU
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput
        label="GPU model"
        maxLength={255}
        mb="sm"
        value={editedData.model}
        onChange={(event) =>
            setEditedData({ ...editedData, model: event.currentTarget.value })
        }
      />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonCancel}>
          Back
        </Button>
        <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
          Save Changes
        </Button>
      </Group>
    </Modal>
  );
};

export default EditGPUModal;
